import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserPackageStart,
  fetchUserPackageSuccess,
  fetchUserPackageFailure,
} from "../redux/slice/PackageManger";
import { activeComponentValue } from "../redux/slice/ActiveComponentSlice";
import { activeChapterValue } from "../redux/slice/ActiveChapterSlice";
import { selectClassValue } from "../redux/slice/SelectClassSlice";
import { handleStudentId } from "../redux/slice/StudentDetailSlice";
import { classActive } from "../redux/slice/ClassAcitveSlice";
import api from "../utils/api";
import useModal from "../hooks/useModal";
import CautionModel from "../Modals/CautionModel";

function Navbar({ setActiveCategory, activeCategory }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [classes, setClasses] = useState([]);
  const [error, setError] = useState(null);
  const isClassActive = useSelector((state) => state.classActive.value);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { visable, Open, Close } = useModal();

  useEffect(() => {
    const fetchUserPackage = async () => {
      const userId = JSON.parse(localStorage.getItem("postUser"))?._id;
      // Loading başlat
      dispatch(fetchUserPackageStart());
      try {
        const response = await api.get("api/userPackage", {
          params: { userId: userId },
        });
        if (response.data.success) {
          const classesData = response.data.classesWithTeacher || [];
          setClasses(classesData);
          if (isClassActive === false && classesData.length > 0) {
            const activeClasses = classesData.filter(
              (item) => item.status === true,
            );
            if (activeClasses.length > 0) {
              const lastActiveClass = activeClasses[activeClasses.length - 1];
              const categoryId = lastActiveClass.id;
              handleCategoryClick(categoryId);
            }
          }

          dispatch(fetchUserPackageSuccess(classesData));
        } else {
          const errorMessage =
            response.data.message || "Unknown error occurred";
          console.error("API returned error:", errorMessage);
          dispatch(fetchUserPackageFailure(errorMessage));
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Network error occurred";

        console.error("Error fetching user package:", {
          message: error.message,
          status: error.response?.status,
          url: error.config?.url,
          data: error.response?.data,
        });

        dispatch(fetchUserPackageFailure(errorMessage));
      }
    };

    fetchUserPackage();
  }, [dispatch]);

  const handleLogout = () => {
    Open("CautionModel");
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleCategoryClick = async (categoryId) => {
    const classMap = {
      1: "class 2",
      2: "class 3",
      3: "class 4",
    };

    const currentClassName = classMap[categoryId];

    if (!currentClassName) return;

    setActiveCategory(categoryId);
    dispatch(activeComponentValue(categoryId));
    setIsMenuOpen(false);

    dispatch(
      activeChapterValue({ chapter: null, title: null, activeId: null }),
    );

    try {
      const userId = JSON.parse(localStorage.getItem("postUser"))?._id;
      const response = await api.get("userClassDetail", {
        params: {
          _id: userId,
          className: currentClassName,
        },
      });

      if (response.status === 200) {
        dispatch(selectClassValue(response.data.classes[0]));
        dispatch(handleStudentId(userId));
        dispatch(classActive(true));
      }
    } catch (error) {
      console.error("API Hatası:", error.response?.data || error.message);
      if (typeof setError === "function") {
        setError(error.response?.data?.message || "Bir hata oluştu");
      }
    }
  };
  return (
    <div className="bg-yellow-500 shadow-xl top-0 sticky z-10 rounded-2xl">
      <div className="py-4 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Mobile Logo */}
          <div className="flex-shrink-0 flex justify-center flex-col items-center lg:hidden">
            <div className="flex items-center group cursor-pointer">
              <img
                src="icons.png"
                alt="icon"
                className="w-20 h-20 rounded-2xl"
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex justify-between items-center w-full">
            {/* Logo - Left */}
            <div className="flex-shrink-0">
              <img
                src="icons.png"
                alt="icon"
                className="w-20 h-20 rounded-2xl"
              />
            </div>

            {/* Navigation Buttons - Center */}
            <div className="flex items-center justify-center flex-1 mx-4">
              <div className="flex items-center justify-center space-x-3">
                {classes.length > 0 &&
                  classes.map(
                    (classItem) =>
                      classItem.status && (
                        <button
                          key={classItem.id}
                          onClick={() => handleCategoryClick(classItem.id)}
                          className={`px-6 py-3 rounded-xl text-lg font-semibold text-white transition-all
                        duration-300 cursor-pointer transform hover:scale-105 group ${
                          activeCategory === classItem.id
                            ? "bg-purple-500 text-white"
                            : "bg-gradient-to-r hover:from-purple-600 hover:to-purple-600"
                        }`}
                          style={{
                            fontFamily:
                              "Inter, system-ui, -apple-system, sans-serif",
                          }}
                        >
                          {classItem.name}
                          <hr
                            className={`border-b ${
                              activeCategory === classItem.id
                                ? "border-yellow-500"
                                : "border-purple-500"
                            } group-hover:border-yellow-500 transition-all duration-300`}
                          />
                          <p className="text-sm font-normal">{classItem.tr}</p>
                        </button>
                        // <div key={classItem.id}>mergaba</div>
                      ),
                  )}
              </div>
            </div>

            {/* Exit Button - Right */}
            <div className="flex-shrink-0">
              <button
                onClick={handleLogout}
                className="px-4 py-2 text-red-500 hover:bg-red-600 group hover:text-white 
              rounded-lg font-semibold transition-all duration-300"
              >
                Exit
                <hr className="border-b border-red-500 group-hover:border-yellow-500" />
                <p className="text-sm">çıkış</p>
              </button>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={toggleMenu}
              className="p-3 rounded-2xl text-white hover:bg-purple-500 transition-all duration-300"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={
                    isMenuOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16M4 18h16"
                  }
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden transition-all duration-500 ease-in-out
      bg-gradient-to-b from-white to-blue-50 ${
        isMenuOpen
          ? "max-h-96 opacity-100 border-t-2 border-blue-200"
          : "max-h-0 opacity-0 overflow-hidden"
      }`}
        style={{
          fontFamily: "Inter, system-ui, -apple-system, sans-serif",
        }}
      >
        <div className="px-4 pt-4 pb-6 space-y-2 ">
          {classes.map(
            (classItem) =>
              classItem.status && (
                <button
                  key={classItem.id}
                  onClick={() => handleCategoryClick(classItem.id)}
                  className={`flex justify-center w-full text-left px-4 py-3 rounded-2xl gap-1
                text-lg font-semibold transition-all duration-300 transform text-white ${
                  activeCategory === classItem.id
                    ? "bg-yellow-500"
                    : "bg-purple-500 hover:bg-yellow-500"
                }`}
                >
                  {classItem.name}
                  <p className="text-sm font-normal mt-1">({classItem.tr})</p>
                </button>
              ),
          )}
          <button
            onClick={handleLogout}
            className="mt-6 flex justify-center gap-1 w-full text-center px-4 py-3 rounded-2xl text-lg font-bold text-white
          bg-purple-500 transition-all duration-300 shadow-lg transform hover:bg-yellow-500"
            style={{
              fontFamily: "Inter, system-ui, -apple-system, sans-serif",
            }}
          >
            Exit
            <p className="text-sm font-normal mt-1">(Çıkış)</p>
          </button>
        </div>
      </div>
      <CautionModel
        visable={visable.CautionModel}
        Close={() => Close("CautionModel")}
      />
    </div>
  );
}

export default Navbar;
